export default {
  clearExperienceState: ({ commit }) => commit("CLEAR_EXPERIENCE_STATE"),

  store: ({ commit }, payload) => commit("store", payload),

  update: ({ commit }, payload) => commit("update", payload),

  delete: ({ commit }, payload) => commit("delete", payload),

  index: ({ commit }, payload) => commit("index", payload),

  onUnskilled: ({ commit }) => commit("ON_UNSKILLED"),
};
